import { useDispatch } from "react-redux";
import { useState, useRef } from "react";
import { Link, useNavigate  } from 'react-router-dom';
import { useForm } from "react-hook-form";
import {  registerAuth } from "./../../reducers/actions/auth";
import Swal from "sweetalert2";

const Register = ({adMesagge, suMessage}) => {

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [successful, setSuccessful] = useState(false);
    const [loading, setLoading] = useState(false)
    const {register, handleSubmit, formState: {errors}, watch } = useForm();
    const password = useRef({});
    
    password.current = watch("password", "");
    
    const [data, setData] = useState({
      email: "",
      name: "",
      documentType: 0,
      documentNumber: "",
      address: "",
      phoneNumber: "",
      password: "",
    });

    const handleInputChange =(e)=>{
      e.preventDefault();
        setData({
            ...data,
        [e.target.name] : e.target.name === 'documentType' ? parseInt( e.target.value): e.target.value
        });
    }

    const onSubmit = (e) => {
      setLoading(true);
      setSuccessful(false);
      dispatch(
        registerAuth(data),
        setLoading(true),
        setSuccessful(true),
        navigate("/login")
      );
    }

    const showAlert = () => {
      Swal.fire({
        title: "Advertencia",
        text: adMesagge,
        icon: "info",
        showDenyButton: true,
        denyButtonText: "No",
        confirmButtonText:"Si",
        confirmButtonColor: "#3085d6",
      }).then(response => {
        if(response.isConfirmed){
          onSubmit();
        }
        if(response.isDenied){
          Swal.fire({
            title: "Cancelado",
            text: "Cancelaste el registro",
            icon: "error",
            confirmButtonText:"Ok",
            confirmButtonColor: "#3085d6",
          })
        } 
      });
    }

    const lDocumentType = [
        { value: 0, label: 'Seleccione un tipo de documento'},
        { value: 1, label: 'Nit', type: 'Nit' },
        { value: 2, label: 'Cedula de ciudadania' , type: 'Identification' },
        { value: 3, label: 'Cedula de extrangeria', type: 'ForeignerId '  },
      ];
      
    return (
      <div className="Register-form-container">
        <form className={`Register-Form`} onSubmit={handleSubmit(showAlert)}>
          <div className="Register-form-content">
            <h3 className="Auth-form-title">Formulario de registro</h3>
            <div className="text-center">
              {" Ya estás registrado? "}
              <Link to={"/"}>Inicia sesión</Link>
            </div>
            <div className="mb-3 row">
              <label htmlFor="email" className="col-sm-4 col-form-label">
                Correo electónico
              </label>
              <div className="col-sm-8">
                <input
                  name="email"
                  placeholder="Correo electrónico"
                  type="email"
                  {...register("email", {
                    required: "Ingresa un correo electronico valido",
                    pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$",
                  })}
                  className="form-control"
                  onChange={handleInputChange}
                />
                {errors?.email && (
                  <span className="danger">{errors.email.message}</span>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label htmlFor="name" className="col-sm-4 col-form-label">
                Nombre
              </label>
              <div className="col-sm-8">
                <input
                  className="form-control"
                  name="name"
                  placeholder="Nombre completo o nombre de empresa"
                  {...register("name", {
                    required: "Este campo es obligatorio",
                  })}
                  type="text"
                  onChange={handleInputChange}
                />
                {errors?.name?.type === "required" && (
                  <span className="danger">{errors.name?.message}</span>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label htmlFor="documentType" className="col-sm-4 col-form-label">
                Tipo de documento
              </label>
              <div className="col-sm-8">
                <select
                  name="documentType"
                  placeholder={"Seleccione un tipo de documento"}
                  className="form-select"
                  onChange={handleInputChange}
                >
                  {lDocumentType.map((option, key) => (
                    <option key={key} value={parseInt(option.value)}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="mb-3 row">
              <label
                htmlFor="documentNumber"
                className="col-sm-4 col-form-label"
              >
                Número de documento
              </label>
              <div className="col-sm-8">
                <input
                  name="documentNumber"
                  placeholder="Numero de documento"
                  type="text"
                  className="form-control"
                  {...register("documentNumber", {
                    required: "Ingresa un numero de documento",
                  })}
                  onChange={handleInputChange}
                />
                {errors?.documentNumber?.type === "required" && (
                  <span className="danger">
                    {errors.documentNumber?.message}
                  </span>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label htmlFor="Address" className="col-sm-4 col-form-label">
                Dirección
              </label>
              <div className="col-sm-8">
                <input
                  name="address"
                  placeholder="Dirección"
                  type="text"
                  className="form-control"
                  {...register("address", {
                    required: "La direccion es requerida.",
                  })}
                  onChange={handleInputChange}
                />
                {errors?.address?.type === "required" && (
                  <span className="danger">{errors.address?.message}</span>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label htmlFor="phoneNumber" className="col-sm-4 col-form-label">
                Télefono
              </label>
              <div className="col-sm-8">
                <input
                  name="phoneNumber"
                  placeholder="Número de telefono"
                  type="number"
                  className="form-control"
                  {...register("phoneNumber", {
                    required: "Ingresa un numero celular o telefonico.",
                  })}
                  onChange={handleInputChange}
                />
                {errors?.phoneNumber?.type === "required" && (
                  <span className="danger">{errors.phoneNumber?.message}</span>
                )}
              </div>
            </div>

            <div className="mb-3 row">
              <label htmlFor="password" className="col-sm-4 col-form-label">
                Contraseña
              </label>
              <div className="col-sm-8">
                <input
                  id="password"
                  name="password"
                  placeholder="Contraseña"
                  type="password"
                  className="form-control"
                  {...register("password", {
                    required: "Debe ingresar una contraseña",
                    minLength: {
                      value: 8,
                      message: "La contraseña debe tener al menos 8 caracteres",
                    },
                    pattern: {
                      value:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#.$($)$-$_])[A-Za-z\d$@$!%*?&#.$($)$-$_]{8,15}$/,
                      message:'La contraseña debe tener letras, numeros y uno o mas caracteres especiales'
                    }
                  })}
                  onChange={handleInputChange}
                />
                {errors?.password && (
                  <span className="danger">{errors.password.message}</span>
                )}
                <div id="passwordHelpBlock" className="form-text">
                  Tu contraseña debe tener entre 8-15 caracteres, debe contener
                  letras y numeros, y uno o mas caracteres especiales, no debe
                  contener espacios.
                </div>
              </div>
            </div>
            <div className="mb-3 row">
              <label
                htmlFor="confirmPassword"
                className="col-sm-4 col-form-label"
              >
                Confirmar contraseña
              </label>
              <div className="col-sm-8">
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="ConfirmarContraseña"
                  type="password"
                  {...register("confirmPassword", {
                    validate: (value) =>
                      value === password.current ||
                      "Las contraseñas deben coincidir",
                  })}
                  className="form-control"
                />
                {errors.confirmPassword && (
                  <span className="danger">
                    {errors.confirmPassword.message}
                  </span>
                )}
                <div id="passwordHelpBlock" className="form-text">
                  Las contraseñas deben coincidir.
                </div>
              </div>
            </div>
            <div className="form-check">
              <input
                id="checkbox1"
                name="checkbox1"
                className="form-check-input"
                {...register("checkbox1", {
                  required:
                    "Debe aceptar los terminos y condiciones para el tratamiento de datos personales",
                })}
                type="checkbox"
              />
              <label className="form-check-label" htmlFor="checkTerms">
                <a
                  href="https://aceitesa.com/wp-content/uploads/visitantes/aviso-privacidad.pdf"
                  target={"_blank"}
                >
                  He leido y acepto los términos y condiciones de tratamiento de
                  datos personales.
                </a>
              </label>
            </div>
            {errors.checkbox1 && (
              <span className="danger">{errors.checkbox1.message}</span>
            )}
            <div className="form-check">
              <input
                id="checkbox2"
                name="checkbox2"
                className="form-check-input"
                {...register("checkbox2", {
                  required:
                    "Debe aceptar los terminos y condiciones del desarrollo de solicitudes de ingreso de contratistas y visitantes",
                })}
                type="checkbox"
              />
              <label className="form-check-label" htmlFor="checkTerms2">
                <a
                  href="https://aceitesa.com/wp-content/uploads/visitantes/aceptacion-ingreso.pdf"
                  target={"_blank"}
                >
                  He leido y acepto los términos y condiciones del desarrollo de
                  solicitudes de ingreso de contratistas y visitantes.
                </a>
              </label>
            </div>
            {errors.checkbox2 && (
              <span className="danger">{errors.checkbox2.message}</span>
            )}
            <div className="mb-3 row">
              <button className='btn btn-success' disabled={loading}>Registrarse</button>
            </div>
          </div>
        </form>
      </div>
    );
}

export default Register